import type { JobSchedulerData, OfferStatus } from '@recruitee/offers-types';

export type OfferActionParam = {
  id: number;
  title: string;
  jobScheduler?: JobSchedulerData;
  status?: OfferStatus;
};

export abstract class OfferActionsFacade {
  public abstract archive(param: OfferActionParam, onSuccess?: () => void): void;
  public abstract duplicate(param: OfferActionParam): void;
  public abstract delete(param: OfferActionParam, onSuccess?: () => void): void;
  public abstract retrieve(param: OfferActionParam, onSuccess?: () => void): void;
}
